module.exports = __webpack_public_path__ + "img/about.bff87bc0.svg";